import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning, f as renderFormField } from './p-Cg8AdZPK.js';
import { t as toValue } from './p-CPuegN2k.js';
import { d as defineCustomElement$p } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$o } from './p-BedvZv52.js';
import { d as defineCustomElement$n } from './p-BN9xIVU9.js';
import { d as defineCustomElement$m } from './p-CVlACDxe.js';
import { d as defineCustomElement$l } from './p-CkgLRZPl.js';
import { d as defineCustomElement$k } from './p-D-k_i6-R.js';
import { d as defineCustomElement$j } from './p-DZKBv4tL.js';
import { d as defineCustomElement$i } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$h } from './p-kuoYNbOB.js';
import { d as defineCustomElement$g } from './p-BVCTlSQE.js';
import { d as defineCustomElement$f } from './p-D4xpFZtu.js';
import { d as defineCustomElement$e } from './p-BkDQJ61k.js';
import { d as defineCustomElement$d } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$c } from './p-DLWyhg_S.js';
import { d as defineCustomElement$b } from './p-B6RR6Z8w.js';
import { d as defineCustomElement$a } from './p-DaiIyqo3.js';
import { d as defineCustomElement$9 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$8 } from './p-DvBrypR4.js';
import { d as defineCustomElement$7 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$6 } from './p-Birh0vlD.js';
import { d as defineCustomElement$5 } from './p-BQe00Bfh.js';
import { d as defineCustomElement$4 } from './p-DbilP0RW.js';
import { d as defineCustomElement$3 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$2 } from './p-QtR5VUMp.js';

const tagsInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;container-type:inline-size;display:flex;flex:1;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.search-input-container{container-type:inline-size}:host([error-type=error]) .tags-list-container,:host([error-type=warning]) .tags-list-container{padding-bottom:0}";

const WuiTagsInput$1 = /*@__PURE__*/ proxyCustomElement(class WuiTagsInput extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        //////// FORM FIELD START ////////
        this.value = [];
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        this.disabled = false;
        this.label = 'Tags';
        this.options = [];
        this.type = 'single-select';
        this.textAreaValue = '';
        this.setValue = (value) => {
            this.dirty = true;
            this.value = value;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
        this.handleSearchChoose = (e) => {
            if (!e.detail.selectedValue) {
                return;
            }
            if (this.type === 'single-select') {
                this.setValue([...(this.value || []), e.detail.selectedValue]);
            }
            if (this.type === 'multiselect') {
                this.setValue(e.detail.selectedValue);
            }
        };
        this.handleTextareaChange = (e) => {
            if (this.type !== 'comma-separated') {
                return;
            }
            this.textAreaValue = e.target.value;
        };
        this.handleAddButtonClick = () => {
            if (this.type !== 'comma-separated') {
                return;
            }
            this.setValue([
                ...(this.value || []),
                ...this.textAreaValue
                    .split(',')
                    .map((s) => s.trim())
                    .filter(Boolean),
            ]);
            this.textAreaValue = '';
        };
        this.handleRemoveTag = (tag) => {
            this.setValue(this.value?.filter((t) => t !== tag) || []);
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    renderInner() {
        return (h(Fragment, null, h("wui-form-field", { label: this.label }, this.type === 'comma-separated' ? (h("wui-layout", { type: "form-section", container: "lg", orientation: "vertical" }, h("wui-layout", { type: "field-button-group", orientation: "vertical" }, h("wui-textarea", { onInput: this.handleTextareaChange, placeholder: `Enter a list of comma separated ${this.label?.toLowerCase() ?? ''}`, disabled: this.disabled }), h("wui-button", { type: "secondary", label: "Add", onClick: this.handleAddButtonClick, disabled: this.disabled })))) : (h("div", { class: "search-input-container" }, h("wui-layout", { type: "form-section", container: "md", orientation: "vertical" }, h("wui-search-input", { placeholder: "Search", selectedValue: this.type === 'multiselect' ? this.value : undefined, options: this.options, excludeOptions: this.type === 'single-select' ? this.value?.map(toValue) : undefined, onChoose: this.handleSearchChoose, disabled: this.disabled, multiselect: this.type === 'multiselect' }))))), h("wui-layout", { class: "tags-list-container", type: "form-section", container: "lg" }, h("wui-form-field", { label: `Added ${(this.label ?? '').toLowerCase()}` }, (this.value?.length ?? 0) > 0 ? (h("wui-tag-list", { type: "contained" }, this.value?.map((tag) => (h("wui-tag", { disabled: this.disabled, key: tag, label: tag, action: "remove", actionTooltip: { label: 'Remove', placement: 'right' }, onClick: () => this.handleRemoveTag(tag) }))))) : (`No ${(this.label ?? '').toLowerCase()} added yet`)))));
    }
    render() {
        return renderFormField(this, this.renderInner());
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return tagsInputCss; }
}, [257, "wui-tags-input", {
        "value": [1040],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "disabled": [516],
        "label": [1],
        "options": [16],
        "type": [513],
        "customValidation": [32],
        "showValidity": [32],
        "textAreaValue": [32]
    }, undefined, {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tags-input", "wui-box", "wui-button", "wui-check-input", "wui-check-list-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-input", "wui-layout", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-menu-pane", "wui-search-input", "wui-status", "wui-tag", "wui-tag-list", "wui-textarea", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tags-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTagsInput$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$p();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$o();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$n();
            }
            break;
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-search-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tag-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTagsInput = WuiTagsInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTagsInput, defineCustomElement };
